import React from 'react';
import { Link } from 'react-router-dom';
import LegalPageLayout from './LegalPageLayout';

const CommunityGuidelinesPage: React.FC = () => (
  <LegalPageLayout title="Community Guidelines" updated="October 5, 2026" draft={false}>
    <p>Bilt:Spec is for documenting real cars and real work. These guidelines apply to builds, clubs, shops, events, Passport, and media.</p>
    <h2>Be accurate</h2>
    <p>Describe parts and work honestly. Do not invent shops, awards, or contributor credit.</p>
    <h2>Be respectful</h2>
    <p>No harassment, hate, threats, sexually explicit content, exploitation, or illegal activity. Use Report content on a build, profile, or community update, or email <a href="mailto:reports@biltspec.com">reports@biltspec.com</a>. You can also use <Link to="/support">Support and safety</Link>. You can block a member to hide their builds and updates while signed in.</p>
    <h2>Respect intellectual property</h2>
    <p>Only upload media and logos you have rights to use. Copyright complaints: see Copyright / DMCA.</p>
    <h2>No fraud</h2>
    <p>Do not fake check-ins, Passport scans, payments, shop claims, or sponsorship eligibility.</p>
    <h2>Enforcement</h2>
    <p>We may remove content, restrict features, or suspend accounts. Send appeals through <Link to="/support">Support and safety</Link>.</p>
  </LegalPageLayout>
);

export default CommunityGuidelinesPage;
